import { useNavigate, useParams } from 'react-router-dom'
import { SubmitHandler } from 'react-hook-form'

import { ResetPullAheadForm } from '@containers/Forms/ResetPullAhead'
import { useResetPullAheadRange } from '@containers/Forms/ResetPullAhead/resetPullAheadRange'
import { TResetForm } from '@containers/Forms/ResetPullAhead/schema'
import { useAlerts } from '@hooks/alerts'
import { useDate } from '@hooks/dates'
import { useAddScheduleFeedbacks } from '@hooks/scheduleFeedbacks'
import { useFindTask } from '@hooks/task/find'
import { RoutesParamsList } from '@services/routes'

export function ResetPullAheadFormScreen() {
  const navigate = useNavigate()
  const params = useParams()
  const taskId = Number(params.taskId)

  const { isPullAhead } = useResetPullAheadRange()
  const { showDismissAlert } = useAlerts()

  const { mutateAsync: postScheduleFeedback } = useAddScheduleFeedbacks()
  const { formatDate } = useDate()

  const { data: rawTask } = useFindTask(taskId)
  const task = rawTask ?? ({} as NonNullable<typeof rawTask>)

  function handleNavigateToTaskList() {
    showDismissAlert(() => navigate(-1))
  }

  const handleSave: SubmitHandler<TResetForm> = async ({
    comment,
    proposedStartTime,
    exceptionEventTypeId,
    isPartial,
    hoursToMove,
  }: TResetForm) => {
    const hoursToMoveParsed = hoursToMove ?? null

    const scheduleFeedback = {
      changeType: isPartial ? 'partial' : 'full',
      comment,
      exceptionEventTypeId: Number(exceptionEventTypeId),
      hoursToMove: hoursToMoveParsed,
      proposedStartTime: proposedStartTime
        ? formatDate(proposedStartTime).dateShort
        : null,
      taskDuration: task.duration,
      type: isPullAhead ? 'Pull Ahead' : 'Reset',
    }

    try {
      await postScheduleFeedback({ id: task.id, scheduleFeedback })
      navigate('/')
    } catch {
      window.alert('Error\n\nFailed to save. Please try again.')
    }
  }

  return (
    <ResetPullAheadForm
      onClose={handleNavigateToTaskList}
      onSave={handleSave}
      task={task}
    />
  )
}
